import React from 'react'


const Card = ({ card }) => {
  return (
    <div className="team" style={{ '--img': `url(${card.imageSrc})` }}>
    <img src={card.imageSrc} alt="Daniel Xavier" />
    <div className="info">
      <div className="org_name">{card.name}</div>
      <div className="org_title">{card.position}</div>
    </div>
  </div>
  )
}

export default Card